<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill">
        <mat-label>Username</mat-label>
        <input matInput [(ngModel)]="searchForm.username" name="username" placeholder="Search by username">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>IP Address</mat-label>
        <input matInput [(ngModel)]="searchForm.ip" name="ip" placeholder="Search by IP address">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Success Status</mat-label>
        <mat-select [(ngModel)]="searchForm.isSuccessful" name="isSuccessful">
          <mat-option [value]="undefined">All</mat-option>
          <mat-option [value]="true">Successful</mat-option>
          <mat-option [value]="false">Failed</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="searchForm.attemptDateFrom" name="attemptDateFrom" placeholder="DD/MM/YYYY">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="searchForm.attemptDateTo" name="attemptDateTo" placeholder="DD/MM/YYYY">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="search-actions">
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
